var React = require('react');
var ReactNative = require('react-native');

var {
  Linking,
} = ReactNative;

module.exports = {
  openURL : function(url, tintColor, barTintColor)
  {
    this.canOpenURL(url, function(canOpen)
    {
      if( canOpen )
      {
        window.open(url,'_blank');
      }
    })
  },

  canOpenURL : function(url, completion)
  {
    Linking.canOpenURL(url).then(supported =>
    {
      completion(supported);
    }).catch(err => console.error('An error occurred', err));
  },

  removeDismissListener : function()
  {

  },

  addDismissListener : function(callback)
  {

  },
}



// WEBPACK FOOTER //
// ./src/wrappers/LinkingManager.js